import { LexbeCoding } from './lexbe-coding.model';

export class LexbeCodingTextBox extends LexbeCoding {
  text: string;
}
